import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import {
  DESKTOP_VISIBLE_CARDS,
  SLIDE_GAP,
} from "~/components/UI/CardsCarousel";

export const Viewport = styled(Box)(() => ({
  overflow: "hidden",
}));

export const Row = styled(Box)(() => ({
  display: "flex",
  gap: SLIDE_GAP,
}));

export const Cell = styled(Box)(({ theme }) => ({
  flex: `0 0 calc((100% - ${(DESKTOP_VISIBLE_CARDS - 1) * SLIDE_GAP}px) / ${DESKTOP_VISIBLE_CARDS})`,
  minWidth: 0,
  [theme.breakpoints.down("sm")]: {
    flex: "0 0 82%",
  },
}));
